import {
  faChartPie,
  faGear,
  faMapPin,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Collapse,
  IconButton,
  Navbar,
  Typography,
} from "@material-tailwind/react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../store/auth";
import logo from "./logo.png";

export default function Topnav() {
  const token = useAuth((state) => state.token);
  const userId = useAuth((state) => state.userId);
  const resetAuth = useAuth((state) => state.resetAuth);
  const [openNav, setOpenNav] = useState(false);

  function logoutUser() {
    if (userId !== "") {
      resetAuth();
    } else {
      alert("No OTP found. User might not be logged in.");
    }
  }

  return (
    <Navbar className="mx-auto max-w-screen-xl py-2 px-4 lg:px-8 lg:py-4">
      <div className="container mx-auto flex items-center justify-between flex-wrap text-blue-gray-900">
        <Typography as="a" href="/mapping" className="mr-4 cursor-pointer py-1.5 font-medium">
          <img className="h-10 w-auto" src={logo} alt="logo_image" />
        </Typography>
        <div className="block md:hidden">
          <IconButton
            variant="text"
            className="ml-auto h-6 w-6 text-black hover:bg-transparent focus:bg-transparent active:bg-transparent"
            ripple={false}
            onClick={() => setOpenNav(!openNav)}
          >
            <FontAwesomeIcon icon={faBars} />
          </IconButton>
        </div>
        {token && userId && (
          <div className="hidden md:flex lg:flex items-center lg:ml-[50%] md:ml-[50%]">
            <Link
              to="/mapping"
              className="m-2 hover:bg-gray-300 rounded-md p-3"
            >
              <FontAwesomeIcon icon={faMapPin} className="mr-1" />
              Mapping
            </Link>
            <Link
              to="/machineInfo"
              className="m-2 hover:bg-gray-300 rounded-md p-3"
            >
              <FontAwesomeIcon icon={faGear} className="mr-1" />
              Machine Info
            </Link>
            <Link
              to="/analytics"
              className="m-2 hover:bg-gray-300 rounded-md p-3"
            >
              <FontAwesomeIcon icon={faChartPie} className="mr-1" />
              Analytics
            </Link>
          </div>
        )}
        <div className="hidden md:block lg:block">
          <Button
            variant="gradient"
            size="sm"
            color="blue"
            onClick={logoutUser}
            className="bg-light-blue-400"
          >
            <span>{token && userId ? "Logout" : "Login"}</span>
          </Button>
        </div>
      </div>
      <Collapse open={openNav} className="md:hidden">
        {token && userId ? (
          <div className="flex flex-col items-start px-4 py-2">
            <Link
              to="/mapping"
              className="w-full mb-2 hover:bg-gray-200 rounded-md p-2 text-black"
              onClick={() => setOpenNav(false)}
            >
              <FontAwesomeIcon icon={faMapPin} className="mr-2 text-black" />
              Mapping
            </Link>
            <Link
              to="/machineInfo"
              className="w-full mb-2 hover:bg-gray-200 rounded-md p-2 text-black"
              onClick={() => setOpenNav(false)}
            >
              <FontAwesomeIcon icon={faGear} className="mr-2 text-black" />
              Machine Info
            </Link>
            <Link
              to="/analytics"
              className="w-full mb-2 hover:bg-gray-200 rounded-md p-2 text-black"
              onClick={() => setOpenNav(false)}
            >
              <FontAwesomeIcon icon={faChartPie} className="mr-2 text-black" />
              Analytics
            </Link>
            <Button
              variant="gradient"
              size="sm"
              color="blue"
              onClick={() => {
                logoutUser();
                setOpenNav(false);
              }}
              className="mt-2 bg-light-blue-400 w-full"
            >
              <span>{token && userId ? "Logout" : "Login"}</span>
            </Button>
          </div>
        ) : (
          <div className="px-4 py-2">Welcome!</div>
        )}
      </Collapse>
    </Navbar>
  );
}